<template lang="html">
 <div class="layout-div__container clearfix">
                <div class="layout-div__title">
                    <span class="layout-span__title__text">
                        <i class="layout-i__line"></i>光滑度
                    </span>
                </div>

                <div class="layout-div__body">
                    <div class="sr-div__smoothness">
                        <img class="sr-img__smoothness" mode="widthFix" src="./imgs/report-bg-egg@2x.png" alt="光滑度"/>
                        <img mode="widthFix" :src="level"
                        alt="剥壳鸡蛋" :style="'left:'+(smoothLevel.coarsenessPicNum-1)*24.6+'%;width:24.6%;height:auto;position:absolute;top:2px;'">
                    </div>
                </div>
                 <ul class="sr-ul__result__group clearfix">
                    <li class="sr-li__result__item">
                        你属于 <i class="layout-i__font big-font">{{smoothLevel.coarseness}}型</i>
                    </li>
                    <li style="margin-top:5px;">
                    {{smoothLevel.coarsenessAdvice}}
                    </li>
                </ul>
            </div>
</template>

<script>
/* eslint-disable */
export default {
  beforeMount () {
    let {coarseness, short_coarseness_advice} = this.$store.state.result.resultData
    this.smoothLevel.coarsenessPicNum = this.smoothLevel.coarsenessType.indexOf(coarseness) + 1
    this.smoothLevel.coarseness = coarseness
    this.smoothLevel.coarsenessAdvice = short_coarseness_advice
  },
  mounted () { 
    let level = require(`./imgs/report-img-egg-0${this.smoothLevel.coarsenessPicNum}-pre@2x.png`)
    this.level = level
  },
  data () {
    return {
      smoothLevel: {
        coarseness: '',
        coarsenessAdvice: '',
        coarsenessPicNum: 1,
        coarsenessType: ['剥壳鸡蛋', '蛋壳', '蛋黄', '煎蛋']
      },
      level: ''
    }
  }
}
</script>

<style scoped>
.sr-div__smoothness{
    width: 100%;
    display: block;
    margin-top: 0.8rem;
    position: relative;
    z-index:1;
}
.sr-img__smoothness{
    width: 100%;
}
.sr-ul__result__group{
    margin: 0;
    padding: 0;
    display: block;
    list-style: none;
    margin-top: 8vw;
    font-size: 4vw;
    font-family: 'PingFangSC'
}
.sr-li__result__item{
    display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/Result/smooth.vue